import React, { useEffect, useState } from "react";
import styled from "styled-components";

// Bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Alert from "react-bootstrap/Alert";

// Componentes
import Notification from "../../components/notification";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { useAuth } from "../../Context/AuthContext";
import { Badge, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { httpClient } from "../../utils/HttpClient";
import CampaignMessageEdit from "./_CampaignMessageEdit";
const Divider = styled.div`
  background: #dfdfdf;
  width: 100%;
  height: 1px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

var today = moment(new Date()).format().split("T")[0];
//var today2 = new Date().toISOString().split("T")[0];
const NewCampaign = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();

  const navigate = useNavigate();
  const activeChannels = ["SMS"];
  const [masksList, setMasksList] = useState(null);
  const [buttonText, setButtonText] = useState("Enviar");
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [listShortLinks, setListShortLinks] = useState(false);
  const [show, setShow] = useState(false);
  const [showPrev, setShowPrev] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isScheduled, setIsScheduled] = useState(false);
  const [listDatabases, setListDatabases] = useState(null);
  const [isDisabled, setIsDisabled] = useState(activeChannels.length > 1);
  const [notificationType, setNotificationType] = useState("");
  const [fieldsInfo, setFieldsInfo] = useState(false);
  const [isSMS, setIsSMS] = useState(true);
  const [isEmail, setIsEmail] = useState(false);
  const [isWhatsApp, setIsWhatsApp] = useState(false);
  const [messageNotification, setMessageNotification] =
    useState("Campaña creada");
  const [values, setValues] = useState({
    campaingName: "",
    uiddatabase: "",
    message: "",
    dateSend: "",
    msisdn: "",
    proghour: "",
    template: "",
    idshortcode: "0",
    mask: "",
  });

  const getListDatabases = (uidpartner) => {
    const URI = ApiEndpoint + "campaigns/getPartnerDatabasesActive";

    httpClient(
      "POST",
      URI,
      {
        id: `${uidpartner}`,
        iduser: userData.uid_user,
      },
      userData.token
    ).then((response) => {
      setListDatabases(response.data);
    });
  };

  const getShortLinks = () => {
    const URI = ApiEndpoint + "campaigns/shortLinks/" + userData.uid_partner;

    httpClient("GET", URI, {}, userData.token).then((response) => {
      setListShortLinks(response.data.filter((x) => x.active));
    });
  };

  const getXtraFieldsInfo = (uidDatabase) => {
    const URIFields = ApiEndpoint + "campaigns/fieldsdatabase/";

    httpClient("GET", URIFields + uidDatabase, {}, userData.token).then(
      (response) => {
        setFieldsInfo(response.data);
      }
    );
  };

  useEffect(() => {
    if (!values.uiddatabase) return;
    getXtraFieldsInfo(values.uiddatabase);
  }, [values.uiddatabase]);

  useEffect(() => {
    if (!fieldsInfo) {
      setShowPrev(true);
      return;
    }
    let messageWithTemplate = values.message;

    let result;
    if (isWhatsApp) {
      try {
        const matches = messageWithTemplate.match(/{{\d+}}/g);

        matches.forEach((match) => {
          var paramArray = values.parameters.split(",");
          let field = paramArray[match.replace("{{", "").replace("}}", "") - 1];

          var currentK = fieldsInfo.filter(
            (item) => item.vc_keycolumn == field.replace(/\s+/g, "")
          );
          console.log("currentK", currentK);
          messageWithTemplate = messageWithTemplate.replace(
            match,
            currentK[0].vc_value
          );
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      var pattern = RegExp("{(.*?)}", "g");
      while ((result = pattern.exec(messageWithTemplate))) {
        // Do something with result[0].

        try {
          var currentK = fieldsInfo.filter(
            (item) => "{" + item.vc_keycolumn + "}" == result[0]
          );
          console.log(currentK);
          messageWithTemplate = messageWithTemplate.replace(
            result[0],
            currentK[0].vc_value
          );
        } catch (error) {
          console.log(error);
        }
      }
    }
    setValues({
      ...values,
      ["template"]: messageWithTemplate.replaceAll("{", "").replaceAll("}", ""),
    });
  }, [values.message]);

  useEffect(() => {
    getListDatabases(userData.uid_partner);
  }, []);

  useEffect(() => {
    //  getCarriersList();
    getShortLinks();
    getAvMask();
  }, []);

  const handleSubmit1 = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    let jDetails = {};
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
    setIsBtnDisabled(true);
    setButtonText("Enviando...");

    if (isWhatsApp) {
      jDetails = {
        parameters: values.parameters + ",",
        template: values.selectedTemplate,
      };
    }

    let URICustomer = ApiEndpoint + "campaigns/createCampaign";
    if (isScheduled) {
      URICustomer = ApiEndpoint + "campaigns/programCampaign";
    }
    getListDatabases(userData.uid_partner);

    httpClient(
      "POST",
      URICustomer,
      {
        name: values.campaingName,
        uiddatabase: values.uiddatabase,
        partner: `${userData.uid_partner}`,
        message: values.message,
        send: values.dateSend,
        hour: isScheduled ? values.proghour.split(":")[0] : 0,
        minute: isScheduled ? values.proghour.split(":")[1] : 0,
        uidUser: userData.uid_user,
        idshortcodemask: values.idshortcode > 0 ? values.idshortcode : null,
        mask: values.mask,
        subject: values.subject,
        isSms: isSMS,
        isEmail: isEmail,
        isWhatsapp: isWhatsApp,
        jDetails: JSON.stringify(jDetails),
      },
      userData.token
    )
      .then(function (response) {
        if (response.data.error) {
          setMessageNotification(
            response.data.Errorcode == "0"
              ? "No cuenta con SMS suficientes para la campaña"
              : "Ya existe una campaña con ese nombre"
          );
          setNotificationType("warning");
          setShow(true);
          setIsBtnDisabled(false);
          setValidated(false);
          setButtonText("Enviar");
        } else {
          setMessageNotification("Campaña creada");
          setNotificationType("");
          setShow(true);
          navigate("/Campaigns");
        }
        return;
      })
      .catch(function (error) {
        setMessageNotification("Ha ocurrido un error");
        setNotificationType("warning");
        setShow(true);
        console.log(error);
      });
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };

  useEffect(() => {
    // getCarriersList();
    getShortLinks();
    //getShortCodes();
  }, []);

  const onChangeWhatsappMessage = (message) => {
    setValues({ ...values, message: message });
  };

  const onChangeWhatsappTemplate = (message) => {
    setValues({ ...values, selectedTemplate: message });
  };

  const cleanWhatsappParameters = () => {
    setValues({ ...values, parameters: "" });
  };
  // const getShortCodes = () => {
  //   const URI = ApiEndpoint + "administration/shortcodesbypartner/";
  //   httpClient("GET", URI + `${userData.uid_partner}`, {}, userData.token).then(
  //     (response) => {
  //       setShortCodesList(response.data);
  //     }
  //   );
  // };

  const getAvMask = () => {
    const URI = ApiEndpoint + "campaigns/masks/";
    httpClient("GET", URI + `${userData.uid_partner}`, {}, userData.token).then(
      (response) => {
        setMasksList(response.data);
      }
    );
  };

  const clickLink = (link) => {
    //  setMessageText(link);
    setValues({
      ...values,
      message: values.message + " " + link + " ",
      template: values.template + " " + link + " ",
    });
  };
  return (
    <>
      <div className="">
        <Form noValidate validated={validated} onSubmit={handleSubmit1}>
          <h2>Nueva campaña</h2>
          <h3>1. Datos generales</h3>

          <FloatingLabel label="Nombre de la campaña *" className="mb-3">
            <Form.Control
              type="text"
              name="campaingName"
              id="campaingName"
              value={values.campaingName}
              required
              onChange={(event) => {
                onChange(event);
              }}
              placeholder="Nombre de la campaña *"
            />
          </FloatingLabel>

          <FloatingLabel label="Base de datos *" className="mb-3">
            <Form.Select
              id="uiddatabase"
              name="uiddatabase"
              value={values.uiddatabase}
              required
              aria-label="select_carrier"
              onChange={(event) => {
                onChange(event);
                setIsDisabled(false);
              }}
            >
              <option value="">Seleccione una opcion de la lista</option>
              {!!listDatabases?.length &&
                listDatabases.map((item) => (
                  <option key={item.uiddatabase} value={item.uiddatabase}>
                    {item.name}
                  </option>
                ))}
            </Form.Select>
          </FloatingLabel>
          <FloatingLabel label="Mascara (opcional)" className="mb-3">
            <Form.Select
              id="mask"
              name="mask"
              onChange={(selectedOption) => {
                onChange(selectedOption);
              }}
              value={values.mask}
              aria-label="select_mask"
            >
              <option value="">Predeterminada</option>
              {!!masksList?.length &&
                masksList.map((mask) => (
                  <option key={mask.vc_mask} value={mask.vc_mask}>
                    {mask.vc_mask}
                  </option>
                ))}
            </Form.Select>
          </FloatingLabel>
          {/* <FloatingLabel
            label="Mascara/Numero corto (opcional)"
            className="mb-3"
          >
            <Form.Select
              id="idshortcode"
              name="idshortcode"
              onChange={(selectedOption) => {
                onChange(selectedOption);
              }}
              value={values.id_shortcode_mask}
              aria-label="select_shortCode"
            >
              <option value="">Seleccione una opcion de la lista</option>
              {!!shortCodesList?.length &&
                shortCodesList.map((shortcode) => (
                  <option value={shortcode.id_shortcode_mask}>
                    {shortcode.vc_mask ?? shortcode.vc_shortcode}
                  </option>
                ))}
            </Form.Select>
          </FloatingLabel> */}
          {/* masksList */}
          <Divider />
          {activeChannels.length > 1 && (
            <>
              <h3>Seleccione el tipo de Mensaje</h3>
              <Row>
                <Col sm={12}>
                  <Form.Check
                    type="radio"
                    id="formHorizontalRadios1"
                    name="formHorizontalRadios"
                    label="SMS"
                    defaultChecked
                    onChange={() => {
                      setIsSMS(true);
                      setIsWhatsApp(false);
                      setIsEmail(false);
                      setValues({
                        ...values,
                        message: "",
                        template: "",
                        dateSend: "",
                        msisdn: "",
                        proghour: "",
                        subject: "",
                        parameters: "",
                      });
                    }}
                  />
                  <Form.Check
                    type="radio"
                    id="formHorizontalRadios2"
                    name="formHorizontalRadios"
                    label="Email"
                    onChange={() => {
                      setIsSMS(false);
                      setIsWhatsApp(false);
                      setIsEmail(true);
                      setValues({
                        ...values,
                        message: "",
                        template: "",
                        dateSend: "",
                        msisdn: "",
                        proghour: "",
                        subject: "",
                        parameters: "",
                      });
                    }}
                  />
                  <Form.Check
                    type="radio"
                    id="formHorizontalRadios2"
                    name="formHorizontalRadios"
                    label="Whatsapp"
                    onChange={() => {
                      setIsSMS(false);
                      setIsWhatsApp(true);
                      setIsEmail(false);
                      setValues({
                        ...values,
                        message: "",
                        template: "",
                        dateSend: "",
                        msisdn: "",
                        proghour: "",
                        subject: "",
                        parameters: "",
                      });
                    }}
                  />
                </Col>
              </Row>
            </>
          )}

          <Divider />
          <h3>
            2.{" "}
            {isWhatsApp
              ? "Seleccione la plantilla"
              : isSMS
              ? "Redacte el mensaje"
              : "Redacte el email"}
          </h3>
          <CampaignMessageEdit
            isSMS={isSMS}
            isWhatsApp={isWhatsApp}
            isEmail={isEmail}
            onChangeWhatsappMessage={onChangeWhatsappMessage}
            onChangeWhatsappTemplate={onChangeWhatsappTemplate}
            cleanWhatsappParameters={cleanWhatsappParameters}
            values={values}
            onChange={onChange}
            listShortLinks={listShortLinks}
            fieldsInfo={fieldsInfo}
            clickLink={clickLink}
            setValues={setValues}
            isDisabled={isDisabled}
          ></CampaignMessageEdit>

          {values.template && showPrev && (
            <>
              <h5 className="PrevTitleModal">Previsualización:</h5>
              <div className="contenedo_msj">
                <div className="mensaje-izq">
                  <div className="cuerpo_msj">
                    {isSMS ? (
                      <div className="msj-texto">{values.template}</div>
                    ) : (
                      <div
                        className="msj-texto"
                        dangerouslySetInnerHTML={{ __html: values.template }}
                      ></div>
                    )}
                  </div>
                </div>
                <Badge
                  className="mt-2"
                  style={{ minWidth: "143px" }}
                  bg="secondary"
                >
                  Max. Caracteres: {values.template.length}
                </Badge>
              </div>
              <hr />
            </>
          )}
          <Divider />
          <h3>3. Programe la campaña (opcional)</h3>
          <h5>
            En caso de no seleccionar esta opción tu campaña se procesará de
            inmediato.
          </h5>

          <FloatingLabel label="" className="mb-3">
            <Form.Check
              type="switch"
              id="isScheduled"
              value={isScheduled}
              label="¿Desas programar la campaña?"
              onChange={() => {
                setIsScheduled(!isScheduled);
              }}
              className="prevent-validation"
            />
          </FloatingLabel>

          {isScheduled ? (
            <>
              <FloatingLabel label="Fecha de envío:" className="mb-3">
                <Form.Control
                  type="date"
                  name="dateSend"
                  id="dateSend"
                  placeholder="Programar"
                  min={today}
                  onChange={(event) => {
                    onChange(event);
                  }}
                  required
                />
              </FloatingLabel>
              <FloatingLabel label="Hora de envío:" className="mb-3">
                <Form.Control
                  type="time"
                  name="proghour"
                  id="proghour"
                  placeholder="Programar"
                  onChange={(event) => {
                    onChange(event);
                  }}
                  required
                />
              </FloatingLabel>
              <Alert key={"secondary"} variant={"secondary"} className="Notice">
                <b>Nota:</b> Si la hora seleccionada ya transcurrió la campaña
                se ejecutará inmediatamente.
              </Alert>
            </>
          ) : (
            <></>
          )}

          <div className="text-right">
            <Button
              disabled={isBtnDisabled}
              variant="primary"
              type="submit"
              className="align-self-end"
            >
              {buttonText}
            </Button>
          </div>
        </Form>
      </div>

      <Notification
        alertType={notificationType}
        show={show}
        setShow={setShow}
        message={messageNotification}
      />
    </>
  );
};

export default NewCampaign;
